import { wealthProApi } from '../../redux/api';

const documentSignatureEndpoints = wealthProApi.enhanceEndpoints({
    addTagTypes: ["documentSignatures"]
}).injectEndpoints({
    endpoints: (builder) => ({ 
        fetchDocumentSignatures: builder.query({
            query: (documentId) => `api/clientdocuments/documents/${documentId}/signatures`,
        })
    })
});

export const {
    useFetchDocumentSignaturesQuery
} = documentSignatureEndpoints;